var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('complaint-list',{attrs:{"mode":"index","api-url":"complaints","title":"Complaints","subtitle":"Review every client complaint, send it for initial handling and verify it once resolved.","icon":"AlertOctagonIcon"}})}
var staticRenderFns = []

export { render, staticRenderFns }